<template>
  <div class="nx-taxonomy-selector-selection">
    <v-chip close v-on="$listeners" :selected="selected">
      <v-avatar>
        <v-icon v-html="icon"></v-icon>
      </v-avatar>
      <span v-html="text"></span>
    </v-chip>
  </div>
</template>

<script>
export default {
  name: 'nx-taxonomy-selector-selection',
  props: {
    id: [String, Number],
    icon: String,
    text: String,
    selected: Boolean,
  },
};
</script>
